export default __webpack_public_path__ + "static/media/img6.1418d941.png";